import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DisplayableItemsComponent } from '../../../../../shared/components/displayable-content/displayable-items/displayable-items.component';
import { WebSpotlightTemplatesViewModel } from './web-spotlight-templates-view-model';

@Component({
  selector: 'app-web-spotlight-templates',
  templateUrl: './web-spotlight-templates.component.html',
  styleUrls: ['./web-spotlight-templates.component.scss'],
  providers: [WebSpotlightTemplatesViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class WebSpotlightTemplatesComponent extends DisplayableItemsComponent {
  constructor(public override viewModel: WebSpotlightTemplatesViewModel) {
    super(viewModel);
  }
}
